import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    fetch(`${API}/auth/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then(async (r) => {
        if (!r.ok) throw new Error("Auth failed");
        return r.json();
      })
      .then((user) => {
        setUser(user);
        window.history.replaceState({}, "", "/");
        navigate("/", { state: { user }, replace: true });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [navigate, setUser]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center" data-testid="auth-callback-loading">
      <p className="font-serif text-2xl text-ink/60 italic">Flegrea Experience…</p>
    </div>
  );
}
